import { useState } from 'react';
import { Table, Button, toaster, Pane, Text, Card, IconButton, EditIcon, RemoveIcon } from 'evergreen-ui';
import { getVolunteers, deleteVolunteer } from '../services/volunteersServices';
import EditVolunteerDialog from './EditVolunteerDialog';
import useWindowSize from '../utils/useWindowSize';
import '../styles/responsive.css';

const VolunteersTable = ({ volunteers, setVolunteers, isEditing }) => {
    const width = useWindowSize();
    const isMobile = width < 920;

    // Stato per Dialog di Modifica
    const [editDialogShown, setEditDialogShown] = useState(false);
    const [editingVolunteer, setEditingVolunteer] = useState(null);

    const refreshVolunteers = async () => {
        try {
            const data = await getVolunteers();
            setVolunteers(data || []);
        } catch (e) {}
    };

    const handleEditClick = (volunteer) => {
        setEditingVolunteer(volunteer);
        setEditDialogShown(true);
    };

    const handleRemoveClick = async (id) => {
        if (!window.confirm('Sei sicuro di voler rimuovere questo volontario?')) return;
        try {
            const result = await deleteVolunteer(id);
            if (result && result.success) {
                toaster.success('Volontario rimosso con successo.');
                refreshVolunteers();
            } else {
                toaster.danger('Errore durante la rimozione.');
            }
        } catch (error) {
            console.error('Errore:', error);
            toaster.danger('Errore durante la rimozione.');
        }
    };    if (isMobile) {
        return (
            <Pane>
                {(!Array.isArray(volunteers) || volunteers.length === 0) ? (
                    <Text>Nessun volontario registrato.</Text>
                ) : (
                    <div className="responsive-list">
                        {volunteers.map(volunteer => (
                            <Card key={`card-${volunteer.id}`} className="responsive-card" background="tint1">
                                <div className="field-row">
                                    <div className="field-label">Nome</div>
                                    <div className="field-value">{volunteer.nome}</div>
                                </div>
                                <div className="field-row">
                                    <div className="field-label">Cognome</div>
                                    <div className="field-value">{volunteer.cognome}</div>
                                </div>
                                <div className="field-row">
                                    <div className="field-label">Data di nascita</div>
                                    <div className="field-value">{volunteer.data_nascita ? volunteer.data_nascita.split('-').reverse().join('/') : ''}</div>
                                </div>

                                <Pane marginTop={16}>
                                    <Text weight={600} marginBottom={8} display="block">Documenti Allegati:</Text>
                                    <Pane display="flex" flexDirection="column" gap={8} paddingY={8}>
                                        {Array.isArray(volunteer.documents) && volunteer.documents.map(doc => (
                                            <Pane key={doc.id} display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                                <Text overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                                                    <a href={doc.file_url} target="_blank" rel="noreferrer">{doc.file_name}</a>
                                                </Text>
                                            </Pane>
                                        ))}
                                    </Pane>
                                </Pane>

                                {isEditing && (
                                    <Pane display="flex" justifyContent="flex-end" marginTop={16} gap={8}>
                                        <Button iconBefore={EditIcon} onClick={() => handleEditClick(volunteer)}>Modifica</Button>
                                        <Button iconBefore={RemoveIcon} intent="danger" onClick={() => handleRemoveClick(volunteer.id)}>Elimina</Button>
                                    </Pane>
                                )}
                            </Card>
                        ))}
                    </div>
                )}
                
                <EditVolunteerDialog 
                    isShown={editDialogShown} 
                    onClose={() => setEditDialogShown(false)} 
                    volunteer={editingVolunteer} 
                    fetchVolunteers={refreshVolunteers} 
                />
            </Pane>
        );
    }

    return (
        <Pane>
            {(!Array.isArray(volunteers) || volunteers.length === 0) ? (
                <Text>Nessun volontario registrato.</Text>
            ) : (
                <Table>
                    <Table.Head>
                        <Table.TextHeaderCell>Nome</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Cognome</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Data di Nascita</Table.TextHeaderCell>
                        <Table.TextHeaderCell flexBasis={300} flexShrink={0} flexGrow={0}>Documenti Allegati</Table.TextHeaderCell>
                        {isEditing && (
                            <Table.TextHeaderCell flexBasis={120} flexShrink={0} flexGrow={0}>Azioni</Table.TextHeaderCell>
                        )}
                    </Table.Head>
                    <Table.Body>
                        {volunteers.map(volunteer => (
                            <Table.Row key={volunteer.id} height="auto" paddingY={8}>
                                <Table.TextCell>{volunteer.nome}</Table.TextCell>
                                <Table.TextCell>{volunteer.cognome}</Table.TextCell>
                                <Table.TextCell>{volunteer.data_nascita ? volunteer.data_nascita.split('-').reverse().join('/') : ''}</Table.TextCell>
                                <Table.Cell flexBasis={300} flexShrink={0} flexGrow={0} display="flex" flexDirection="column" gap={8} paddingY={8}>
                                    {Array.isArray(volunteer.documents) && volunteer.documents.map(doc => (
                                        <Pane key={doc.id} display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                            <Text overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                                                <a href={doc.file_url} target="_blank" rel="noreferrer">{doc.file_name}</a>
                                            </Text>
                                        </Pane>
                                    ))}
                                </Table.Cell>
                                {isEditing && (
                                    <Table.Cell flexBasis={120} flexShrink={0} flexGrow={0} display="flex" flexDirection="row" gap={8} alignItems="center" justifyContent="center">
                                        <IconButton icon={EditIcon} onClick={() => handleEditClick(volunteer)} title="Modifica" />
                                        <IconButton icon={RemoveIcon} intent="danger" onClick={() => handleRemoveClick(volunteer.id)} title="Elimina" />
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            )}

            <EditVolunteerDialog 
                isShown={editDialogShown} 
                onClose={() => setEditDialogShown(false)} 
                volunteer={editingVolunteer} 
                fetchVolunteers={refreshVolunteers} 
            />
        </Pane>
    );
};

export default VolunteersTable;
